<template>
    <ul class="nav_breadcrumbs">
        <li><router-link to="/modules/home">{{lang.LBL_HOME}}</router-link></li>
        <li><router-link to="/modules/comments/edit">{{lang.LBL_ADD_COMMENT}}</router-link></li>
        <li><router-link to="/modules/comments">{{lang.LBL_VIEW_COMMENT}}</router-link></li>
    </ul>
</template>
<script>
import lang from "@/views/modules/Comments/language/en";
export default {
    name: "breadcrumbs",
    data() {
        return {
            lang:[],
           
        }
     },
     mounted() {
        this.lang = lang;
       
    },
    methods:{
       
    }
}
</script>
